var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row col-md-6" }, [
      _vm.show.includes("assetsUnderManagment")
        ? _c("div", [
            _c("label", [_vm._v(" Assets Under Management (AUM)")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-11 input-group" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.assetsUnderManagment,
                    expression: "assetsUnderManagment"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  step: "1",
                  min: "0",
                  max: "100000000000"
                },
                domProps: { value: _vm.assetsUnderManagment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.assetsUnderManagment = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("minimumInvestment")
        ? _c("div", [
            _c("label", [_vm._v(" Minimum Investment in USD")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-11 input-group" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.minimumInvestment,
                    expression: "minimumInvestment"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  step: "1",
                  min: "0",
                  max: "100000000"
                },
                domProps: { value: _vm.minimumInvestment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.minimumInvestment = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("maximumInvestment")
        ? _c("div", [
            _c("label", [_vm._v(" Maximum Investment in USD")]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-11 input-group" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.maximumInvestment,
                    expression: "maximumInvestment"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  step: "1",
                  min: "0",
                  max: "100000000"
                },
                domProps: { value: _vm.maximumInvestment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.maximumInvestment = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("avgAmountRaised")
        ? _c("div", [
            _c("label", [_vm._v(" Average Amount Invested in USD")]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-11 input-group" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.avgAmountRaised,
                    expression: "avgAmountRaised"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  step: "1",
                  min: "0",
                  max: "100000000"
                },
                domProps: { value: _vm.avgAmountRaised },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.avgAmountRaised = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("numberOfInvestments")
        ? _c("div", [
            _c("label", [_vm._v(" Number of Investments")]),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-md-11 input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.numberOfInvestments,
                    expression: "numberOfInvestments"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", step: "1", min: "0", max: "10000" },
                domProps: { value: _vm.numberOfInvestments },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.numberOfInvestments = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("timeToExitInDays")
        ? _c("div", [
            _c("label", [_vm._v(" Time to Close Deal")]),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group col-md-11 input-group",
                staticStyle: { width: "120px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeToExitInDays,
                      expression: "timeToExitInDays"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "padding-right": "0px" },
                  attrs: { type: "number", step: "1", min: "0", max: "1000" },
                  domProps: { value: _vm.timeToExitInDays },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.timeToExitInDays = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(7)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("timeToExitInYears")
        ? _c("div", [
            _c("label", [_vm._v(" Time to Exit ")]),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group col-md-11 input-group",
                staticStyle: { width: "120px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeToExitInYears,
                      expression: "timeToExitInYears"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "padding-right": "0px" },
                  attrs: { type: "number", step: "0.01", min: "0", max: "100" },
                  domProps: { value: _vm.timeToExitInYears },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.timeToExitInYears = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(9)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("successRate")
        ? _c("div", [
            _c("label", [_vm._v(" Success Rate")]),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group col-md-11 input-group",
                staticStyle: { width: "100px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.successRate,
                      expression: "successRate"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "padding-right": "0px" },
                  attrs: { type: "number", step: "1", min: "0", max: "100" },
                  domProps: { value: _vm.successRate },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.successRate = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(11)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("averageIrrSought")
        ? _c("div", [
            _c("label", [
              _vm._v("Average Internal Rate of Return (IRR) Sought")
            ]),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group col-md-11 input-group",
                staticStyle: { width: "100px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.averageIrrSought,
                      expression: "averageIrrSought"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { "padding-right": "0px" },
                  attrs: {
                    type: "number",
                    step: "1",
                    min: "-100",
                    max: "1000"
                  },
                  domProps: { value: _vm.averageIrrSought },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.averageIrrSought = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(13)
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("boardSeat")
        ? _c("div", [
            _c(
              "div",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "10px" }
              },
              [
                _c("label", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("Board Seat")
                ]),
                _vm._v(" "),
                _vm._m(14),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.boardSeat,
                      expression: "boardSeat"
                    }
                  ],
                  attrs: { type: "radio", id: "one", value: "1" },
                  domProps: { checked: _vm._q(_vm.boardSeat, "1") },
                  on: {
                    change: function($event) {
                      _vm.boardSeat = "1"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { for: "one" }
                  },
                  [_vm._v("Yes")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.boardSeat,
                      expression: "boardSeat"
                    }
                  ],
                  attrs: { type: "radio", id: "two", value: "0" },
                  domProps: { checked: _vm._q(_vm.boardSeat, "0") },
                  on: {
                    change: function($event) {
                      _vm.boardSeat = "0"
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "two" } }, [_vm._v("No")])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.show.includes("femaleFocus")
        ? _c("div", [
            _c(
              "div",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "10px" }
              },
              [
                _c("label", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("Focus on Female Entrepreneurs")
                ]),
                _vm._v(" "),
                _vm._m(15),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.femaleFocus,
                      expression: "femaleFocus"
                    }
                  ],
                  attrs: { type: "radio", id: "one", value: "1" },
                  domProps: { checked: _vm._q(_vm.femaleFocus, "1") },
                  on: {
                    change: function($event) {
                      _vm.femaleFocus = "1"
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { for: "one" }
                  },
                  [_vm._v("Yes")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.femaleFocus,
                      expression: "femaleFocus"
                    }
                  ],
                  attrs: { type: "radio", id: "two", value: "0" },
                  domProps: { checked: _vm._q(_vm.femaleFocus, "0") },
                  on: {
                    change: function($event) {
                      _vm.femaleFocus = "0"
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "two" } }, [_vm._v("No")])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("$")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("$")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("$")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [_vm._v("Average amount invested per company.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("$")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [_vm._v("Total number of investments provided to date.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Average amount of time taken to perform due diligence and invest in\n          firm."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("Days")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "How long does this provider stay involved with companies before\n          looking to exit."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("Years")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Number of successful investments over total number of\n          investments."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("%")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [_vm._v("Rate of return sought on investment.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { background: "white", width: "10px" }
      },
      [_c("span", [_vm._v("%")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Does the provider take a board seat on the company it's investing\n            in?"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("small", [
        _vm._v(
          "Do you have a specific focus on funding women-owned\n            businesses?"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdaec3c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdaec3c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/stats.vue
// module id = 189
// module chunks = 0